var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainBackgroundLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 937,
    viewBox: "0 0 509 937",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter0_f_64_313)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -112,
    y: 180,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -132,
    y: 160,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter1_f_64_313)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 220,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 200,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter2_f_64_313)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 315,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 295,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter3_f_64_313)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: -10,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter4_f_64_313)"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 85,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: -30,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 65,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter5_f_64_313)"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -112,
    y: 410,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter6_f_64_313)"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -112,
    y: 640,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter7_f_64_313)"
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 462,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter8_f_64_313)"
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 557,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: -132,
    y: 390,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: -132,
    y: 620,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 442,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 537,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_64_313",
    x: -198.985,
    y: 93.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_64_313",
    x: -0.985016,
    y: 133.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_64_313",
    x: 207.015,
    y: 228.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_64_313",
    x: -0.985016,
    y: -96.985,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_64_313",
    x: 207.015,
    y: -1.98502,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_64_313",
    x: -198.985,
    y: 323.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_64_313",
    x: -198.985,
    y: 553.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_64_313",
    x: -10.985,
    y: 375.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_64_313",
    x: 197.015,
    y: 470.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBackgroundLeft);
export default __webpack_public_path__ + "static/media/mainBackgroundLeft.9291d91e3b034052cd2e554efad33483.svg";
export { ForwardRef as ReactComponent };